import { NgModule } from '@angular/core';

// modules (angular)
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// modules
import { SharedModule } from '../../shared/shared.module';

// components
import { FooterComponent } from './footer.component';
import { TotopComponent } from './components/totop/totop.component';

@NgModule({
    declarations: [
        FooterComponent,
        TotopComponent
    ],
    imports: [
        // modules (angular)
        CommonModule,
        RouterModule,
        // modules
        SharedModule
    ],
    exports: [
        FooterComponent
    ]
})
export class FooterModule { }
